import hhkjsq from '@/common/hhkjsq.js'
const {hosts} = hhkjsq
// var MAX_POST_LENGTH = 100
var emotions = ['爱你', '傲慢', '抱抱', '鄙视', '闭嘴', '打哈哈', '鼓掌', '哈哈', '哈欠', '害羞', '好困', '好色', '黑线', '加油', '可爱', '可怜', '酷', '狂晕', '流泪', '怒骂', '钱', '偷笑', '吐', '挖鼻屎', '委屈', '我打', '嘻嘻', '小丑', '嘘', '晕', '再见', '左哼哼', '爱心传递', '蜡烛', '赞', '差', '互粉', '伤心', '给力', '围观', '小八打招呼', '小八卖萌', '小八馋嘴', '小八捏脸', '小八惊吓', '小八擦汗', '小八美梦', '小八花痴', '小八石化', '小八犯困', '小八委屈', '小八大哭', '小八发火', '小八怒骂', '小八得意', '小八白眼', '小八奋斗', '小八抠鼻', '小八赞', '小八傲慢', '小八闭嘴', '小八调皮', '小八饿', '小八通知', '小八咧嘴', '小八撇嘴', '小八亲', '小八生日', '小八衰', '小八偷笑', '小八吓', '小八嘘', '小八疑问', '小八晕倒', '小八抓狂', '小八耶']

var url = {
  emotion: function (name) {
    return hosts.shuocdn + '/frontEnd/external/TCSay/emotion/default/' + (emotions.indexOf(name) + 1) + '.gif'
  }
}

var ubb = {
  /* eslint-disable */
  link: {
    regStart: /\[link([^\]]+)?\]/g,
    regEnd: /\[\/link\]/g,
    replace: function (sText, isRemoveStyle) {
      var self = this;
      if (isRemoveStyle) {
        return self.remove(sText);
      }
      return sText.replace(self.regStart, function (sMatch, sSub) {
        sSub = !sSub ? '' : sSub.replace(/href="([^"]+)"/, function (sMatch, sSub) {
          var h = decodeURIComponent(sSub), l = Talk.parseWapLink(h);
          return ['href="', l, '"'].join('');
        });
        sSub = !sSub ? '' : sSub.replace(/target="([^"]+)"/, function (sMatch, sSub) {
          return '';
        });
        sSub = !sSub ? '' : sSub.replace(/style="([^"]+)"/g, function (sMatch, sSub) {
          return ['style="', sSub.replace(/＃/g, '#'), '"'].join('');
        });
        return ['<a', sSub, '>'].join('');
      }).replace(self.regEnd, '<\/a>');
    },
    remove: function (sText) {
      return sText.replace(this.regStart, '').replace(this.regEnd, '');
    }
  },
  font: {
    regStart: /\[span([^\]]+?)?\]/g,
    regEnd: /\[\/span\]/g,
    replace: function (sText, isRemoveStyle) {
      var self = this;
      if (isRemoveStyle) {
        return self.remove(sText);
      }
      return sText.replace(self.regStart, function (sMatch, sSub) {
        sSub = !sSub ? '' : sSub.replace(/style="(.+)"/g, function (sMatch, sSub) {
          return ['style="', sSub.replace(/＃/g, '#'), '"'].join('');
        });
        return ['<span', sSub, '>'].join('');
      }).replace(self.regEnd, '<\/span>');
    },
    remove: function (sText) {
      return sText.replace(this.regStart, '').replace(this.regEnd, '');
    }
  },
  p: {
    regStart: /\[p([^\]]+?)?\]/g,
    regEnd: /\[\/p\]/g,
    replace: function (sText, isRemoveStyle) {
      var self = this;
      if (isRemoveStyle) {
        return self.remove(sText);
      }
      return sText.replace(self.regStart, function (sMatch, sSub) {
        sSub = !sSub ? '' : sSub.replace(/style="(.+)"/g, function (sMatch, sSub) {
            return ['style="', sSub.replace(/＃/g, '#'), '"'].join('');
        });
        return ['<p', sSub, '>'].join('');
      }).replace(self.regEnd, '<\/p>');
    },
    remove: function (sText) {
      return sText.replace(this.regStart, '').replace(this.regEnd, '');
    }
  },
  br: {
    reg: /\[br(\/)?\]/g,
    replace: function (sText, isRemove) {
      return sText.replace(this.reg, isRemove ? '' : '<br>');
    },
    remove: function (sText) {
      return this.replace(sText, true);
    }
  },
  img: {
      reg: /\[img([^\]]+?)?\]/g,
      replace: function (sText, isRemove) {
        if (isRemove) {
          return sText.replace(this.reg, '');
        }
        return sText.replace(this.reg, function (sMatch, sSub) {
          sSub = !sSub ? '' : sSub.replace(/src="([^\"\']+)"/g, function (sMatch, sSub) {
            var sSub = unescape(sSub);
            if (!/^http:\/\//.test(sSub)) { //非绝对地址
                sSub = Talk.HOST_SHOWIMG + sSub;
            }
            return ['src="', sSub, '"'].join('');
          });
          return ['<img', sSub, '\/>'].join('');
        });
    },
    remove: function (sText) {
      return this.replace(sText, true);
    }
  },
  video:{
    reg:/\[video([^\[\]]+)\]/g,
    replace: function (sText, isRemove) {
      if (isRemove) {
        return sText.replace(this.reg, '');
      }
      return sText.replace(this.reg, function (sMatch, sSub) {
        sSub = !sSub ? '' : sSub.replace(/src="([^\"\']+)"/g, function (sMatch, sSub) {
            var sSub = unescape(sSub);
             return ['data-videoSrc="', sSub, '"'].join('');
         }).replace(/width="([0-9]*)"/g,function(sMatch, sSub){
             return ['data-width="', sSub, '"'].join('');
         }).replace(/height="([0-9]*)"/g,function(sMatch, sSub){
             return ['data-height="', sSub, '"'].join('');
        });
        var videoImg = params.arrImg.shift();
        var str= '  data-videoImg="'+videoImg[0]+'"';
        return ['<span class="video" ', sSub,str,'\/><img src="',videoImg[0],'"/><span class="playVideo"></span></span>'].join('');
      });
    },
    remove: function (sText) {
      return this.replace(sText, true);
    }
  },
  topic: {
    reg: /(#([^#]+)#)/g,
    replace: function (sText, isRemove) {
      if (isRemove) {
        return sText.replace(this.reg, '')
      }
    },
    remove: function (sText) {
      return this.replace(sText, true)
    }
  },
  mention: {
    reg: /(@([^@\s,:：;；,，\[\]]{1,16}?))([\s,:：;；,，\[\]]|$)/g,
    replace: function (sText, isRemove) {
      if (isRemove) {
        return sText.replace(this.reg, '')
      }
    },
    remove: function (sText) {
      return this.replace(sText, true)
    }
  },
  picSymbol: {
    reg: /\[图片\d*\]/g,
    replace: function (sText, isRemove) {
      if (isRemove) {
        return sText.replace(this.reg, '')
      }
    },
    remove: function (sText) {
      return this.replace(sText, true)
    }
  },
  getCleanText: function (sText) {
    var self = this;
    sText = self.p.remove(sText);
    sText = self.link.remove(sText);
    sText = self.font.remove(sText);
    sText = self.br.remove(sText);
    sText = self.img.remove(sText);
    sText = self.video.remove(sText);
    sText = self.topic.remove(sText);
    sText = self.mention.remove(sText);
    sText = self.picSymbol.remove(sText);
    return sText;
  }
}

export var parseVideo = function (content) {
  var exp = /\[video([^\[\]]+)\]/g
  var result = exp.exec(content)
  if (result) {
    var srcReg = /src="([^\"\']+)"/g
    var src = srcReg.exec(result[1])
    return src[1]
  }
  return false
}

export var parsePost = function (content, ishost) {
  let exp = /\[post\sid=["|']([^\]]+)["|']\]/
  let result = exp.exec(content)
  if (result && ishost) {
    return result[1] || false
  }
  return false
}

function filterPostContent (content, postId) {
  content = ubb.getCleanText(content)
  return content
}

export var parseContent = function (content, postId) {
  try{
    content = decodeURIComponent(content)
  }catch (e) {
      console.log("filter:js decodeURIComponent content error")
  }
  // 过滤标签
  content = content.replace(/<\/*[a-zA-Z]+[^>]*>/g, '')

  // 过滤video标签
  content = content.replace(/\[video[^[\]]+\]/g, '')

  var length = content.length
  // 替换表情
  content = content.replace(/\s?(\/([\u4e00-\u9fa5]+)\/)\s?/g,
    function () {
      if (emotions.indexOf(arguments[2]) > -1) {
        return '<img src="' + url.emotion(arguments[2]) + '" class="emotion">'
      }
      return arguments[1]
    }
  )

  // 替换帖子标识符
  content = content.replace(/\[post[^[\]]+\]/g, '加载帖子中')
  // 过滤帖子内容
  if (postId) {
    content = filterPostContent(content, postId)
    // length = content.length
    // if (content.length > MAX_POST_LENGTH) {
    // }
  }

  return {
    content: content,
    length: length
  }
}



// WEBPACK FOOTER //
// ./src/utils/filter.js